import React from 'react';

import { LoansLandingPage } from '@Loans/LoansLanding';
import { LoansPretotypePage } from '@Loans/LoansPretotype';

import { AppFeature, useIsFeatureEnabled } from '../../config';

const LoansRedirect: React.FC = () => {
  const { isFeatureEnabled } = useIsFeatureEnabled();
  const cryptoBackedLoansEnabled = isFeatureEnabled(AppFeature.CryptoBackedLoans);

  return (
    <div>
      {/* When the crypto-backed loans feature is enabled we want the Loans route to show the feature implementation */}
      {/* if not we want it to show the pretotype loans page if that is enabled, if neither are enabled, the route will be hidden in Router.tsx */}
      {cryptoBackedLoansEnabled ? <LoansLandingPage /> : <LoansPretotypePage />}
    </div>
  );
};

export { LoansRedirect };
